module.exports = __webpack_public_path__ + "img/werbe-pro.eebfe55.svg";